const useLoadingProps = {
  loading: { type: Boolean, default: false }
};
export {
  useLoadingProps as u
};
//# sourceMappingURL=useLoading.js.map
